import React from 'react'

import BusinessEventsPromo from '../../../../assets/images/promo-business-events.png'

import './BusinessEventsUpsell.scss'

export const BusinessEventsUpsellBody: React.FC = () => {
  return (
    <>
      <img src={BusinessEventsPromo} alt='Client signals promo' className='zocks-border-0.5 business-events-upsell-promo object-fit-contain' />
      <div className='d-flex flex-column gap-1'>
        <h5>
          Automate with <span className='zocks-text-primary'>Client Signals</span>
        </h5>
        <div className='paragraph-medium'>
          Your AI Assistant detects important signals from meetings - such as life events and referrals - then triggers your Zapier workflows automatically.
        </div>
      </div>
    </>
  )
}

export const BusinessEventsUpsellFeatures: React.FC = () => {
  return (
    <>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Spot opportunities</strong>: Life events and referrals are highlighted in every meeting note
        </div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Save hours on data entry</strong>: Signals flow to Zapier without manual updates
        </div>
      </div>
      <div className='d-flex gap-2 mb-3'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Never miss a follow-up</strong>: Trigger workflows the moment signals are detected
        </div>
      </div>
    </>
  )
}
